import { render, staticRenderFns } from "./SellLandList.vue?vue&type=template&id=37a07bb0&scoped=true&"
import script from "./SellLandList.vue?vue&type=script&lang=js&"
export * from "./SellLandList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a07bb0",
  null
  
)

export default component.exports